import React from 'react';

const VisionMission = () => {
  return (
    <section id="vision" className="py-12 px-6 bg-gray-100 text-primary">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-3xl font-bold mb-4">Vision</h3>
        <p className="mb-6">
          Graduates of CTS succeed in a global society by being respectful, productive citizens who embrace education as a lifelong process. Staff and parents work as a team to help learners set, reach, and exceed their goals.
        </p>
        <h3 className="text-3xl font-bold mb-4">Mission</h3>
        <p>
          To create a challenging environment that encourages high expectations for success through developing appropriate instruction. Improve learners' skills to make decisions, stimulate critical creative thinking, and foster freedom and justice.
        </p>
      </div>
    </section>
  );
};

export default VisionMission;



